import { render, staticRenderFns } from "./HTMLViewer.vue.js?vue&type=template&id=c8a80ece&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HTMLViewer.vue?vue&type=template&id=c8a80ece&scoped=true"
import script from "./HTMLViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HTMLViewer.vue?vue&type=script&lang=js"
export * from "./HTMLViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HTMLViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a80ece",
  null
  
)

export default component.exports